import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["appContext", "buttonProps", "inDetailsPageContext", "isEmbedded", "previewListingId", "slug", "userInfo"];
import getLang from 'I18n/utils/getLang';
import { getDataFetchingClientRequestState } from 'marketplace-ui-common/dataFetchingClient/utils/getDataFetchingClientRequestState';
import LoadingWrapper from 'marketplace-ui-common/layout/components/LoadingWrapper';
import { DetailsPageContext } from '../context/DetailsPageContext';
import { useListingPreview } from '../hooks/useListingPreview';
import { useTracking } from '../hooks/useTracking';
import { useUnifiedDetails } from '../hooks/useUnifiedDetails';
import { AgentCTAButton } from './AgentCTAButton';
import { AppCTAButton } from './AppCTAButton';
import { SolutionsPartnerProfileCTAButton } from './SolutionsPartnerProfileCTAButton';
import { jsx as _jsx } from "react/jsx-runtime";
export function MarketplaceListingCTAButton(_ref) {
  let {
      appContext,
      buttonProps,
      inDetailsPageContext = false,
      isEmbedded = false,
      previewListingId,
      slug,
      userInfo
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const published = !!slug && !previewListingId;
  const isPreview = !!previewListingId;
  const isSolutionsPartnerProfile = slug === null || slug === void 0 ? void 0 : slug.includes('profile:');

  // TODO: Remove once id is no longer required
  const {
    unifiedDetailsData: unifiedDetailsDataV2,
    unifiedDetailsLoading: unifiedDetailsLoadingV2,
    unifiedDetailsError: unifiedDetailsErrorV2
  } = useUnifiedDetails({
    appContext,
    language: getLang(),
    skip: !slug || isPreview || isSolutionsPartnerProfile,
    slug: slug || '',
    version: 2
  });
  const {
    unifiedDetailsData: unifiedDetailsDataV3,
    unifiedDetailsLoading: unifiedDetailsLoadingV3,
    unifiedDetailsError: unifiedDetailsErrorV3
  } = useUnifiedDetails({
    appContext,
    language: getLang(),
    skip: !slug || isPreview,
    slug: slug || '',
    version: 3
  });
  const {
    previewData,
    previewLoading,
    previewError
  } = useListingPreview({
    appContext,
    language: getLang(),
    listingId: previewListingId,
    skip: !isPreview
  });

  // TODO: Remove once id is no longer required
  const unifiedDetailsRequestStatusV2 = getDataFetchingClientRequestState(unifiedDetailsErrorV2, unifiedDetailsLoadingV2);
  const unifiedDetailsRequestStatusV3 = getDataFetchingClientRequestState(unifiedDetailsErrorV3, unifiedDetailsLoadingV3);
  const previewRequestStatus = getDataFetchingClientRequestState(previewError, previewLoading);
  const {
    id
  } = previewData || unifiedDetailsDataV2;
  const {
    agentType,
    appSignInConfiguration,
    betaDetails,
    builtByHubSpot,
    companyName,
    companyUrl,
    connectionType,
    features,
    installUrl,
    isDashworks,
    isMcpConnector,
    isMcpServer,
    isOpsHub,
    listingIcon,
    listingId,
    name,
    productFeatures,
    productType,
    sourceId,
    urlSlug
  } = previewData || unifiedDetailsDataV3;
  const {
    trackInstall,
    trackInteraction
  } = useTracking({
    appContext,
    companyName,
    embed: isEmbedded,
    isPreview,
    listingId,
    slug: urlSlug,
    sourceId,
    type: productType
  });
  let renderedCTAButton = null;
  if (productType === 'AGENT') {
    renderedCTAButton = /*#__PURE__*/_jsx(AgentCTAButton, Object.assign({
      "data-test-id": "cta-button",
      agentType: agentType,
      betaDetails: betaDetails,
      installUrl: installUrl,
      slug: slug || urlSlug,
      sourceId: sourceId
    }, buttonProps, rest));
  }
  if (productType === 'APP') {
    renderedCTAButton = /*#__PURE__*/_jsx(AppCTAButton, Object.assign({
      "data-test-id": "cta-button",
      appSignInConfiguration: appSignInConfiguration,
      builtByHubSpot: builtByHubSpot,
      connectionType: connectionType,
      features: features,
      installUrl: installUrl,
      isDashworks: isDashworks,
      isOpsHub: isOpsHub,
      previewListingId: previewListingId,
      productFeatures: productFeatures,
      slug: slug || urlSlug,
      sourceId: sourceId,
      showSecondaryCta: inDetailsPageContext,
      fullWidth: inDetailsPageContext
    }, buttonProps, rest));
  }
  if (productType === 'SOLUTIONS_PARTNER_PROFILE') {
    renderedCTAButton = /*#__PURE__*/_jsx(SolutionsPartnerProfileCTAButton, {
      companyUrl: companyUrl
    });
  }
  if (!renderedCTAButton) {
    return null;
  }
  if (inDetailsPageContext) {
    //ignore context setup if already wrapped by Details component
    return renderedCTAButton;
  }
  return /*#__PURE__*/_jsx(LoadingWrapper, {
    requestStatus: [unifiedDetailsRequestStatusV2, unifiedDetailsRequestStatusV3, previewRequestStatus],
    children: /*#__PURE__*/_jsx(DetailsPageContext.Provider, {
      value: {
        appContext,
        iconUrl: listingIcon === null || listingIcon === void 0 ? void 0 : listingIcon.value,
        isEmbedded,
        isMcpConnector,
        isMcpServer,
        listingId,
        // TODO: Remove once id is no longer required
        listingIdV2: id,
        previewListingId,
        name,
        productType,
        published,
        runLeadGen: () => {},
        trackInstall,
        trackInteraction,
        userInfo
      },
      children: renderedCTAButton
    })
  });
}